import Vue from 'vue'
import VueRouter from 'vue-router'
import guard from '@/guard'
import {
  canShowFinancialAnalysis,
  canShowMap,
  canShowPartners,
  canShowSchedule,
} from '@/helpers/organizationFeatureVisibility'
import other from '@/router/other'
import routes from '@/router/routes'
import { withTenantKey } from '@/libs/storageKeys'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...other,
    ...routes,
  ],
})

const getStoredOrganizationConfig = () => {
  try {
    const rawConfig = localStorage.getItem('organizationConfig')

    if (!rawConfig) {
      return null
    }

    return JSON.parse(rawConfig)
  } catch (error) {
    return null
  }
}

const isOrganizationFeatureHidden = organizationFeature => {
  if (!organizationFeature) {
    return false
  }

  const config = getStoredOrganizationConfig()
  if (config == null) {
    return false
  }

  switch (organizationFeature) {
    case 'financialAnalysis':
      return !canShowFinancialAnalysis(config)
    case 'map':
      return !canShowMap(config)
    case 'schedule':
      return !canShowSchedule(config)
    case 'partners':
      return !canShowPartners(config)
    default:
      return false
  }
}

router.beforeEach((to, from, next) => {
  const publicPages = ['/login'] // future:'/register'
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem(withTenantKey('userInfo'))
  const routeRoles = to.meta.roles
  const userRoles = localStorage.getItem(withTenantKey('userInfo')) ? JSON.parse(localStorage.getItem(withTenantKey('userInfo'))).roles : []

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  if (authRequired && typeof routeRoles !== 'undefined') {
    const accessGranted = guard.hasAtLeastOneRole(userRoles, routeRoles)
    if (!accessGranted) {
      window.toast.notify.warning('Access denied', `You don't have access to ${to.path}`)
      return next(from.path)
    }
  }

  if (authRequired && isOrganizationFeatureHidden(to.meta.organizationFeature)) {
    return next('/')
  }

  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.onError(error => {
  if (/loading chunk [\w\d-]+ failed./i.test(error.message)) {
    window.location.reload()
  }
})

export default router
